import { render } from "./PaqueteProducto.vue?vue&type=template&id=c16a0490&scoped=true"
import script from "./PaqueteProducto.vue?vue&type=script&lang=js"
export * from "./PaqueteProducto.vue?vue&type=script&lang=js"

import "./PaqueteProducto.vue?vue&type=style&index=0&id=c16a0490&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c16a0490"]])

export default __exports__